if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if (!this.hasAttribute('available')) return;

      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);
    }

    fetchAvailability(variantId) {
      let rootUrl = this.dataset.rootUrl;

      if (!rootUrl.endsWith('/')) {
        rootUrl = rootUrl + '/';
      }

      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then((response) => response.text())
        .then((text) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');

          this.renderPreview(sectionInnerHTML);
        })
        .catch(() => {
          this.renderError();
        });
    }

    onClickRefreshList() {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = '';
    }

    renderPreview(sectionInnerHTML) {
      const root = sectionInnerHTML?.querySelector('.pickup-availability-root');

      if (!root) {
        this.innerHTML = '';
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = root.innerHTML;
      this.setAttribute('available', '');
    }
  });
}

window.selectPickupStore = function (button) {
  if (!button) return;

  const productId = button.dataset.productId;
  const drawerId = button.dataset.drawerId;
  const locationName = button.dataset.name || '';
  const pickupTime = button.dataset.time || '';
  const isAvailable = button.dataset.available === 'true';

  if (!productId) return;

  const nameTarget = document.getElementById(`pickup-location-name-${productId}`);
  const timeTarget = document.getElementById(`pickup-location-time-${productId}`);

  if (nameTarget) {
    nameTarget.textContent = locationName;
  }

  if (timeTarget) {
    timeTarget.textContent = isAvailable
      ? pickupTime
      : 'Récupération actuellement indisponible';
  }

  if (drawerId) {
    const drawer = document.getElementById(drawerId);

    if (drawer) {
      if (typeof drawer.hide === 'function') {
        drawer.hide();
      } else {
        drawer.removeAttribute('open');
      }
    }
  }

  document.documentElement.classList.remove('lock-all');
  document.body.classList.remove('lock-all');
  document.body.classList.remove('open-cc');
};